import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    top: 0; bottom: 0;
    /* top: 70px; */
    width: 100%;
    max-width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export {
    Container
}